export interface Testimonial {
  /** Attribution line exactly as written in the sales letter */
  attribution: string
  name: string
  age: number
  role: string
  location: string
  headline: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    attribution: 'Illustrative Welding Inspector Feedback',
    name: 'Mark Delgado',
    age: 44,
    role: 'Structural Steel Welding Inspector',
    location: 'Houston, Texas, United States',
    headline: 'Weld discontinuities are much easier to compare visually.',
    quote:
      'Reading defect descriptions is one thing, but having organized visual references makes it much easier to understand the differences between common welding discontinuities.',
  },
  {
    attribution: 'Illustrative QC Technician Feedback',
    name: 'Rachel Thompson',
    age: 33,
    role: 'QC Technician, Pressure Piping',
    location: 'Edmonton, Alberta, Canada',
    headline: 'The measurement references are incredibly practical.',
    quote:
      'Having weld geometry, gauge techniques, and dimensional recording examples organized together makes reviewing inspection measurements much more convenient.',
  },
  {
    attribution: 'Illustrative Fabrication Inspector Feedback',
    name: 'Gareth Hughes',
    age: 52,
    role: 'Fabrication Shop Inspector',
    location: 'Sheffield, United Kingdom',
    headline: 'A much more organized approach to welding inspection.',
    quote:
      'Joint configurations, discontinuities, NDT methods, quality requirements, and inspection documentation are all connected. Having them organized into visual modules is useful.',
  },
  {
    attribution: 'Illustrative Quality Control Professional Feedback',
    name: 'Natalie Brooks',
    age: 39,
    role: 'Quality Control Coordinator, Mining Fabrication',
    location: 'Perth, Western Australia, Australia',
    headline: 'The reporting templates add practical value.',
    quote:
      'Working with inspection checklists, NCR forms, measurement records, and reinspection templates helps make quality documentation more structured and consistent.',
  },
  {
    attribution: 'Illustrative Welding Inspection Student Feedback',
    name: 'Tyler Jensen',
    age: 26,
    role: 'Welder Training Toward Inspection',
    location: 'Pittsburgh, Pennsylvania, United States',
    headline: 'A visual inspection resource worth keeping available.',
    quote:
      'The defect references, weld measurement guides, NDT comparisons, and practical inspection scenarios make this a useful companion for reviewing welding inspection concepts.',
  },
]
